import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCart, clearCart } from "../utils/cartUtils";
import { toast } from "react-toastify";

export default function Checkout() {
  const cart = getCart();
  const cartItems = cart.items || [];
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState(""); // حالة لتتبع طريقة الدفع
  const [paymentError, setPaymentError] = useState(""); // حالة لخطأ طريقة الدفع

  const subtotal = cartItems
    .reduce((sum, item) => sum + parseFloat(item.price) * item.quantity, 0)
    .toFixed(2);
  const delivery = 5.0;
  const discount = 0.0;
  const total = (parseFloat(subtotal) + delivery - discount).toFixed(2);

  const handleConfirmOrder = () => {
    // التحقق من اختيار طريقة الدفع
    if (!paymentMethod) {
      setPaymentError("Please select a payment method.");
      toast.error("Please select a payment method!", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    // مسح السلة من localStorage
    clearCart();

    // عرض رسالة التوست
    toast.success("شكرًا لطلبك!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });

    // إعادة التوجيه للصفحة الرئيسية
    navigate("/");
  };

  return (
    <section className="py-10">
      <div className="container mx-auto">
        <div className="flex items-center gap-4 mb-6">
          <h1 className="text-2xl font-bold">Checkout</h1>
        </div>

        {cartItems.length === 0 ? (
          <div className="text-center py-10">Your cart is empty.</div>
        ) : (
          <>
            <div className="p-4 border border-[#20bcb4] rounded-lg mb-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-bold">My Order</h2>
                <span className="font-bold">${total}</span>
              </div>
              {cartItems.map((item) => (
                <div key={item.id} className="flex justify-between mb-2">
                  <span>
                    {item.name} ({item.quantity} x ${item.price})
                  </span>
                  <span>
                    ${(parseFloat(item.price) * item.quantity).toFixed(2)}
                  </span>
                </div>
              ))}
              <div className="flex justify-between mb-2">
                <span>Discount</span>
                <span>-${discount.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>Delivery</span>
                <span>${delivery.toFixed(2)}</span>
              </div>
            </div>

            <div className="p-4 bg-white rounded-lg shadow-[0_0_10px_#0000001a] mb-6">
              <h2 className="text-lg font-bold mb-4">Payment Method</h2>
              <div className="flex flex-col gap-3">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="VISA"
                    checked={paymentMethod === "VISA"}
                    onChange={(e) => {
                      setPaymentMethod(e.target.value);
                      setPaymentError("");
                    }}
                    className="w-5 h-5"
                  />
                  <span className="text-lg">VISA</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="CASH"
                    checked={paymentMethod === "CASH"}
                    onChange={(e) => {
                      setPaymentMethod(e.target.value);
                      setPaymentError("");
                    }}
                    className="w-5 h-5"
                  />
                  <span className="text-lg">CASH</span>
                </label>
              </div>
              {paymentError && (
                <div className="text-red-500 mt-2">{paymentError}</div>
              )}
            </div>

            <button
              onClick={handleConfirmOrder}
              className="w-full bg-[#20bcb4] text-white py-3 rounded-lg font-bold"
            >
              Confirm Order
            </button>
          </>
        )}
      </div>
    </section>
  );
}